
import type { SetupContext } from 'vue'
import { defineComponent } from 'vue'

import XTogglePanel from '../../components/x/x-toggle-panel.component.vue'

import { ColorEnum } from '../../enums'

import { EpbBadge } from '../shared/epb-badge'
import { EpbButton } from '../shared/epb-button'
import { EpbText } from '../shared/epb-text'
import TransitionSize from '../transition-size.component.vue'

export default defineComponent({
  name: 'EqualizeFeatureContainer',
  components: {
    XTogglePanel,
    EpbText,
    TransitionSize,
    EpbBadge,
    EpbButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    defaultButtonDisabled: Boolean,
    description: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  setup(props, ctx: SetupContext) {
    const { emit } = ctx

    const baseClass = 'epb-equalize-feature-container'

    const setDefaultValues = (): void => {
      emit('setDefaultValues')
    }

    return {
      baseClass,
      setDefaultValues,
      ColorEnum,
    }
  },
})
